import React from "react";
import { useTranslation } from "../i18n/TranslationProvider";
import NewFeatureDemos from "./NewFeatureDemos";
import ResourcesPatientCaregiver from "./ResourcesPatientCaregiver";
import juneNewsletterPdf from "../constants/juneNewsletter.pdf";

const Resources = ({userType}) => {
  const { t } = useTranslation();

  return (
    // Provider View
    <div className="container mt-4">
       {userType === "provider" ? ( <>
      <h2>{t("dashboard.resources.title")}</h2>
      

      <section className="mt-4">
        <h4>{t("dashboard.resources.forms")}</h4>
        <ul>
          <li>
            <a href="https://forms.cloud.microsoft/pages/responsepage.aspx?id=gxBGbdm66ECZbn5psfLnRwMgEdq_7OJJhXTsyptmlEdUNjNJRlc1QTBINE5OMkY3RTZEMjBBRFNPOS4u&route=shorturl" target="_blank" rel="noopener noreferrer">{t("dashboard.resources.formLinks.addClinic")}</a>
          </li>
          <li>
            <a href="https://forms.cloud.microsoft/pages/responsepage.aspx?id=gxBGbdm66ECZbn5psfLnRwMgEdq_7OJJhXTsyptmlEdUNDBIODVWSDU4WjJXOVBEV0VLWlpCMlA0Qy4u&route=shorturl" target="_blank" rel="noopener noreferrer">{t("dashboard.resources.formLinks.changeProviderStatus")}</a>
          </li>
          <li>
            <a href="https://forms.cloud.microsoft/pages/responsepage.aspx?id=gxBGbdm66ECZbn5psfLnRwMgEdq_7OJJhXTsyptmlEdUNENJUUdIRENGWEVEODU0Tk4ySDNYU1NERS4u&route=shorturl" target="_blank" rel="noopener noreferrer">{t("dashboard.resources.formLinks.movePatientCaregiver")}</a>
          </li>
        </ul>
      </section>

      <section className="mt-4">
        <h4>{t("dashboard.resources.newsletters")}</h4>
        <ul>
          <li>
            <a href="https://preview.mailerlite.io/preview/1519849/emails/187906391495673430" target="_blank" rel="noopener noreferrer">{t("dashboard.resources.newsletterLinks.may2026")}</a>
          </li>
          <li>
            <a href={juneNewsletterPdf} target="_blank" rel="noopener noreferrer">{t("dashboard.resources.newsletterLinks.june2026")}</a>
          </li>
          <li>
            <a href="https://dashboard.mailerlite.com/emails/195509791652579139/preview" target="_blank" rel="noopener noreferrer">{t("dashboard.resources.newsletterLinks.july2026")}</a>
          </li>
        </ul>
      </section>

        <NewFeatureDemos />

      <section className="mt-4">
        <h4>{t("dashboard.resources.dataReporting")}</h4>
        <ul>
          <li>
            <a href="https://app.powerbi.com/view?r=eyJrIjoiYmFhYWE4YjgtYTQxYy00YzAxLTkyOGYtYjkwOWIzZWJiMWU3IiwidCI6IjZkNDYxMDgzLWJhZDktNDBlOC05OTZlLTdlNjliMWYyZTc0NyIsImMiOjN9" target="_blank" rel="noopener noreferrer">{t("dashboard.resources.dataReportingLink")}</a>
          </li>
        </ul>
      </section>
      </>
      ): (
        // View for Patients and Caregivers

         <ResourcesPatientCaregiver />
        )}
    </div> 
  );
};

export default Resources;